'use client';

import BackgroundContainer from '@components/BackgroundContainer';
import Button from '@components/Button';
import Link from 'next/link';

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  return (
    <BackgroundContainer
      className='error-page'
      aria-label='Ein Fehler ist aufgetreten'
      as='section'
      variant='not-found'
    >
      <div className='not-found__actions'>
        <h1 className='not-found__title'>Fehler</h1>
        <h2>Ein Fehler ist aufgetreten.</h2>

        {/* Development mode: Show error details */}
        {process.env.NODE_ENV === 'development' && (
          <div className='container'>
            <details
              style={{
                marginTop: '2rem',
                textAlign: 'left',
                width: '100%',
              }}
            >
              <summary style={{ cursor: 'pointer', marginBottom: '1rem' }}>Technische Details</summary>
              <pre
                style={{
                  background: 'rgba(0,0,0,0.1)',
                  padding: '1rem',
                  borderRadius: '4px',
                  fontSize: '0.875rem',
                  overflow: 'auto',
                }}
              >
                {error.message}
                {'\n\n'}
                {error.stack}
              </pre>
            </details>
          </div>
        )}

        <div
          style={{
            display: 'flex',
            gap: '1rem',
            marginTop: '2rem',
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}
        >
          <Button ghost white onClick={() => reset()}>
            Erneut versuchen
          </Button>
          <Link href='/'>
            <Button ghost white>
              Zurück zur Startseite
            </Button>
          </Link>
        </div>
      </div>
    </BackgroundContainer>
  );
}
